const authErrorKeyMapMixin = {
  computed: {
    castErrorKeyToLang() {
      return ({ key, error_code }) => {
        return this.authErrorLangKeyMapper(key, error_code);
      };
    },
  },
  methods: {
    authErrorLangKeyMapper: function(key, error_code) {
      const keyToField = {
        first_name: "Usrs_first_name",
        last_name: "Usrs_last_name",
        email: "Comn_email",
        password: "Usrs_pwd",
        current_password: "Usrs_old_password",
        confirm_password: "Comn_confirm_pwd",
        country: "Comn_country",
        name: "Comn_country",
        phone: "Comn_mobile_num",
        timezone: "Comn_timezone",
      };
      const keyToInvalid = {
        first_name: {
          INVALID_VALUE: "Usrs_first_name_wrng_format",
          VALUE_DO_NOT_HAVE_MIN_CHAR: "min_character_for_field",
          VALUE_HAVE_MAX_CHAR: "max_character_for_field",
        },
        last_name: {
          INVALID_VALUE: "Usrs_first_name_wrng_format",
          VALUE_DO_NOT_HAVE_MIN_CHAR: "min_character_for_field",
          VALUE_HAVE_MAX_CHAR: "max_character_for_field",
        },
        email: {
          INVALID_VALUE: "Usrs_email_in_valid_format",
        },
        password: {
          INVALID_VALUE: "Usrs_pwd_wrng_frmt",
          VALUE_DO_NOT_HAVE_MIN_CHAR: "Usrs_pwd_wrng_frmt",
        },

        confirm_password: {
          INVALID_VALUE: "Usrs_pwd_cnpwd_valida",
          VALUE_DO_NOT_HAVE_MIN_CHAR: "Usrs_pwd_wrng_frmt",
          VALUES_SHOULD_MATCH:
            "both_the_password_and_confirm_password_must_match",
        },
        country: { INVALID_VALUE: "Comn_country" },
        phone: { INVALID_VALUE: "Comn_mobile_num_valid" },
        timezone: { INVALID_VALUE: "Comn_timezone_not_valid" },
      };
      const fieldTranslation = this.$t(keyToField[key]);
      switch (error_code) {
        case "FIELD_REQUIRED":
          return this.$t("Comn_field_is_required", { field: fieldTranslation });
        case "INVALID_VALUE":
          return this.$t(keyToInvalid[key].INVALID_VALUE);
        case "VALUES_SHOULD_MATCH":
          return this.$t(keyToInvalid[key].VALUES_SHOULD_MATCH);
        case "VALUE_DO_NOT_HAVE_MIN_CHAR":
          return this.$t(keyToInvalid[key].VALUE_DO_NOT_HAVE_MIN_CHAR, {
            field: fieldTranslation,
          });
        case "VALUE_HAVE_MAX_CHAR":
          return this.$t(keyToInvalid[key].VALUE_HAVE_MAX_CHAR, {
            field: fieldTranslation,
          });
        default:
          if (key && error_code) return this.$t(keyToInvalid[key][error_code]);
      }
    },
  },
};
export default authErrorKeyMapMixin;
